import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { useStores } from "@stores";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@stores/AccountStore";
import Spinner from "@components/Spinner";
import { checkAdmin } from "@services/adminService";

const LoadingLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  background: rgba(256, 256, 256, 0.5);
`;

const AdminRoute: React.FC = ({ children }) => {
  const { accountStore } = useStores();
  const [adminChecked, setAdminChecked] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (accountStore.authenticated) {
      checkAdmin()
        .then((result) => {
          setIsAdmin(result.isAdmin);
          setAdminChecked(true);
        })
        .catch(() => {
          setIsAdmin(false);
          setAdminChecked(true);
        });
    }
  }, [accountStore.authenticated]);

  if (!accountStore.initialized) {
    return (
      <LoadingLayout>
        <Spinner />
      </LoadingLayout>
    );
  }

  if (!accountStore.authenticated) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  if (!adminChecked) {
    return (
      <LoadingLayout>
        <Spinner />
      </LoadingLayout>
    );
  }

  if (!isAdmin) {
    return <Navigate to={ROUTES.FIELDS} />;
  }

  return <>{children}</>;
};

export default observer(AdminRoute);
